import { useFormikContext } from "formik";
import { VisibilityProps } from "models/propTypes/genericFormProps";

function useCheckVisibility<T extends Record<string, any>>() {
  const { values } = useFormikContext<any>();

  const getFieldHidden = (fieldHidden?: boolean | VisibilityProps<T> | ((values: any) => boolean)): boolean => {
    let isHidden = undefined;

    switch (typeof fieldHidden) {
      case "boolean":
        isHidden = fieldHidden as boolean;
        break;
      case "function":
        isHidden = fieldHidden(values);
        break;
      default:
        const visibilityProps = fieldHidden as VisibilityProps<T>;

        if (fieldHidden && Array.isArray(fieldHidden.hiddenWhenEqualTo)) {
          isHidden = fieldHidden.hiddenWhenEqualTo.includes(values[fieldHidden.referenceFieldName]);
        } else {
          // eslint-disable-next-line eqeqeq --- since dynamically checked
          isHidden = fieldHidden && values[visibilityProps.referenceFieldName] == visibilityProps.hiddenWhenEqualTo;
        }

        break;
    }

    return !!isHidden;
  };

  return {
    getFieldHidden,
  };
}

export default useCheckVisibility;
